const Theme = {
  logo_image_url: 'stationfmr.png',

  button_color: 'black',
  button_font: `'Raleway', sans-serif`,
  button_text_uppercase: false,
  button_text_color: 'black',
  button_radius: 50,
  button_centered: true,
  button_no_border: true,
  button_background_url: '/static/background/stationfmr/jaune.png',

  text_font: `'Lato', sans-serif`,
  title_font: `'Raleway', sans-serif`,

  photobooth_button_color: 'white',
  photobooth_button_text_color: 'black',
}

export default Theme
